import constantes from '../helpers/constanteHelper'

import { useNavigate } from 'react-router-dom'

import Image from 'react-bootstrap/Image';

function OpcaoMenuInicial({ cor, imagem, path }) {
    const navigate = useNavigate();

    return (
        <div onClick={() => { navigate(path) }} style={{ cursor: 'pointer', width: '200px', height: '200px', background: cor, borderRadius: '20px' }}>
            <div style={{ height: '200px' }} className='d-flex flex-column align-items-center justify-content-center p-4' >
                {imagem ? <Image src={imagem} alt='logo' fluid /> : <></>}
            </div>
        </div>
    );
}
export default OpcaoMenuInicial;
